


















import { InviteService } from '@/admin/InviteService';
import InviteForm from '@/components/InviteForm.vue';
import Toolbar from '@/components/Toolbar.vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from 'vue-property-decorator';

@Component({
  components: {
    Toolbar,
    InviteForm,
  },
})
export default class InviteAdmin extends Vue {
  @Inject('inviteService')
  private inviteService!: InviteService;
}
